import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    const update = () => {
      if (!anchor) {
        setVisible(window.scrollY > 620);
        return;
      }
      const rect = anchor.getBoundingClientRect();
      setVisible(rect.bottom < 8);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return <AnimatePresence data-id="element-31" data-mp="2atqqc9krejcq">
      {visible ? <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-[#0E3B42]/10 bg-[#FBF8F3]/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-sm sm:border-0 sm:bg-transparent sm:px-6 sm:pb-6 sm:backdrop-blur-none" data-id="element-32" data-mp="38b8la1fqwcls">
          <div className="mx-auto flex w-full max-w-md flex-col items-center sm:max-w-sm sm:items-end" data-id="element-33" data-mp="2pabk78wv58iz">
            <a href={CHECKOUT_URL} className="animate-cta-shake block w-full rounded-xl bg-[#D79B2B] px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide text-[#2A1B00] shadow-[0_14px_34px_-12px_rgba(14,59,66,0.55)] transition-colors duration-200 ease-out hover:bg-[#C88C1E] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0E3B42]" data-id="element-34" data-mp="2fdyh5kffhibk">
              Ottieni l’accesso per €19
              <span className="mt-0.5 block text-[11px] font-bold normal-case tracking-normal text-[#4A3200]" data-id="element-35" data-mp="9l04fofs9mc6">
                Pagamento unico · Garanzia 7 giorni
              </span>
            </a>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}